import React, { ComponentProps, useCallback } from 'react';

import { Autocomplete, Checkbox, TextField } from '@mui/material';

const TOUR_STYLE_OPTIONS: Array<string> = ['Deluxe', 'Premium', 'Ultra Lux', 'Signature Series', 'Custom'];

interface Props {
  value: Array<string>;
  onChange: (newValue?: Array<string>) => void;
}

export default function TourOfferTourStyleInput({ value, onChange }: Props) {
  const handleChange = useCallback<ComponentProps<typeof Autocomplete>['onChange']>(
    (e, nextValue: Array<string>) => {
      onChange(nextValue);
    },
    [onChange],
  );

  return (
    <Autocomplete
      value={value}
      onChange={handleChange}
      fullWidth
      multiple
      options={TOUR_STYLE_OPTIONS}
      openOnFocus
      disableCloseOnSelect
      getOptionLabel={(option: string) => option}
      renderOption={(props, option: string, { selected }) => (
        <li {...props}>
          <Checkbox checked={selected} />
          {option}
        </li>
      )}
      renderInput={(params) => <TextField {...params} label="Tour Styles" />}
    />
  );
}
